import React from "react";
import "../../css/sharedStyles.css";
import SearchBox from "../searchBox/SearchBoxContainer.js";
import NavMenu from "../navMenu/navMenu.js";


var HeaderContainer = class HeaderContainer extends React.Component{
  constructor(props) {
      super(props);

  }  
  componentWillMount(){
  }//end componentWillMount() 

  componentWillUpdate(){
  }

  componentDidUpdate(){
  }

  render() {
      const inlineStyle = {
        padding:"4px 0",
        width:"100%",
        float:"left",
        textAlign:"center",
        marginBottom:"10px"
      }
      return (
        <div style = {inlineStyle} className="content_box_square">
          <SearchBox 
            changeCharacter = {this.props.changeCharacter}  
            changeFeaturedComics = {this.props.changeFeaturedComics}
            characterInfo = {this.props.characterInfo}
            changeRelatedCharacters = {this.props.changeRelatedCharacters}
            showFeaturedArea = {this.props.showFeaturedArea}
            showComicArea = {this.props.showComicArea}
            showCharacterPopup = {this.props.showCharacterPopup}
            
          />

          <NavMenu 
            pagination = {this.props.pagination} 
            menu = {this.props.menu}
            changeCurrentPage = {this.props.changeCurrentPage}
            />
        </div>
      );
    }
  }

export default HeaderContainer;


// WEBPACK FOOTER //
// ./src/components/header/HeaderContainer.js